import { useEffect } from 'react';
import { UseFormReturn, useForm, useFormContext } from 'react-hook-form';
import { buildShipToCreationResolver } from '../validators';
import { ShipToCreationData } from './shipToCreationData';
import { ShipToCreationForm } from './shipToCreationForm.types';

export const useShipToCreationFormContext = () => useFormContext<ShipToCreationForm, ShipToCreationData>();

export const useShipToCreationForm = <T extends ShipToCreationData>(
  initShipTo: ShipToCreationForm,
): {
  shipToCreationForm: UseFormReturn<ShipToCreationForm, T>;
} => {
  const shipToCreationForm = useForm<ShipToCreationForm, T>({
    defaultValues: initShipTo,
    values: initShipTo,
    resolver: buildShipToCreationResolver(),
    reValidateMode: 'onChange',
    mode: 'onChange',
    criteriaMode: 'all',
    resetOptions: {
      keepDirty: true,
    },
  });

  useEffect(() => {
    shipToCreationForm.trigger();
  }, [shipToCreationForm, shipToCreationForm.trigger]);

  return {
    shipToCreationForm,
  };
};
